import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  popOverBg: {
    backgroundColor: '#000000',
    color: '#ffffff',
  },
  menuItemAction: {
    '&:hover': {
      backgroundColor: '#454141',
    },
  },
}))

const Actions = (props) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  let {
    enableCounterOffer,
    enableDeleteLineItem,
    enableRejectOffer,
    enableAcceptOffer,
    handleRatesDialog,
    item,
    handleAcceptRejectOffer,
    handleOpenProposeOfferDialog,
    handleUpdatePOLineDetails
  } = props;

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <React.Fragment>
      <Button
        endIcon={<ArrowDropDownIcon fontSize='small' />}
        onClick={handleOpenMenu}
        style={{
          backgroundColor: 'black',
          color: 'white',
          borderRadius: '20px',
          textTransform: 'capitalize',
          padding: '0.5rem 1rem 0.5rem 1rem',
        }}
      >
        Actions
      </Button>
      <Menu
        id='negotiation-menu-cost-sheet'
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        getContentAnchorEl={null}
        PopoverClasses={{
          paper: classes.popOverBg,
        }}
      >
        {enableAcceptOffer === true && (
          <MenuItem
            className={classes.menuItemAction}
            onClick={() => {
              // handleAcceptRejectOffer(item, 'Accept Offer');
              handleUpdatePOLineDetails("acceptOfferFlag",item,[])
              handleClose();
            }}
          >
            <Typography variant='body2'> Accept Offer</Typography>
          </MenuItem>
        )}
        {enableCounterOffer === true && (
          <MenuItem
            className={classes.menuItemAction}
            onClick={() => {
              handleOpenProposeOfferDialog(item)
              handleClose();
            }}
          >
            <Typography variant='body2'> Propose Counter Offer</Typography>
          </MenuItem>
        )}
        {enableRejectOffer === true && (
          <MenuItem
            className={classes.menuItemAction}
            onClick={() => {
              // handleAcceptRejectOffer(item, 'Reject Offer');
              handleUpdatePOLineDetails("rejectOfferFlag",item,[])
              handleClose();
            }}
          >
            <Typography variant='body2'>Reject Offer</Typography>
          </MenuItem>
        )}
        {enableDeleteLineItem === true && (
          <MenuItem
            className={classes.menuItemAction}
            onClick={() => {
              // handleAcceptRejectOffer(item, 'Delete Offer');
              handleUpdatePOLineDetails("itemDeleteFlag",item,[])
              handleClose();
            }}
          >
            <Typography variant='body2'>Delete line item</Typography>
          </MenuItem>
        )}
      </Menu>
    </React.Fragment>
  );
};

Actions.propTypes = {
  enableCounterOffer: PropTypes.bool.isRequired,
  enableAcceptOffer: PropTypes.bool.isRequired,
  enableRejectOffer: PropTypes.bool.isRequired,
  enableDeleteLineItem: PropTypes.bool.isRequired,
};

export default Actions;
